<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Import adresów
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="shippingLabelAddress.contactPerson"
                            :error-messages="contactPersonErrors"
                            label="Osoba kontaktowa"
                            outlined
                            dense
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="shippingLabelAddress.phoneNumber"
                            v-mask="'(+##) #########'"
                            :error-messages="phoneNumberErrors"
                            label="Telefon"
                            outlined
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-file-input
                            v-model="currentFile"
                            label="Plik excel"
                            accept=".xls, .xlsx"
                            counter
                            placeholder="Wybierz plik"
                            prepend-icon="mdi-paperclip"
                            outlined
                            dense
                            :rules="[fileError]"
                            :show-size="1000"
                        />
                    </v-col>
                </v-row>

                <v-divider />
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        @click="onClose()"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        text
                        data-sentry-label="Wyślij plik"
                        :disabled="!canUpload"
                        @click="onLoaded"
                    >
                        <v-icon left>
                            mdi-file-upload
                        </v-icon>
                        Wyślij
                    </v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import * as XLSX from 'xlsx'
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'

export default {
    name: 'ImportAddressDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        }
    },
    data() {
        return {
            shippingLabelAddress: {
                contactPerson: null,
                phoneNumber: null
            },
            reader: null,
            currentFile: null,
            xlsData: null,
            isValidFileTrigger: true,
        }
    },
    computed: {
        canUpload() {
            return this.currentFile && this.isValidFileTrigger
        },
        fileError() {
            return this.isValidFileTrigger || 'Niepoprawny format danych w pliku.'
        },
        contactPersonErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.contactPerson.$dirty) return errors
            !this.$v.shippingLabelAddress.contactPerson.required && errors.push('Proszę podać osobę do kontaktu.')

            return errors
        },
        phoneNumberErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.phoneNumber.$dirty) return errors
            !this.$v.shippingLabelAddress.phoneNumber.required && errors.push('Proszę podać numer telefonu.')

            return errors
        },
    },
    watch: {
        currentFile(value) {
            if (value !== null && value !== undefined) {
                this.reader.readAsBinaryString(value)
            } else {
                this.currentFile = null
                this.xlsData = null
                this.isValidFileTrigger = true
            }
        },
        xlsData(data) {
            if (this.currentFile !== null) {
                this.isFileValid(data)
            }
        }
    },
    mounted() {
        this.reader = new FileReader()

        this.reader.onload = (e) => {
            const bstr = e.target.result
            const wb = XLSX.read(bstr, { type: 'binary' })
            /* Get first worksheet */
            const wsname = wb.SheetNames[0]
            const ws = wb.Sheets[wsname]

            /* Convert array of arrays */
            this.xlsData = XLSX.utils.sheet_to_json(ws, { header: 1 })
        }
    },
    validations() {
        return {
            shippingLabelAddress: {
                contactPerson: {
                    required
                },
                phoneNumber: {
                    required
                }
            }
        }
    },
    methods: {
        isFileValid(data) {
            if (data === null) {
                return (this.isValidFileTrigger = false)
            } else if (!data[0].length) {
                return (this.isValidFileTrigger = false)
            }

            if (!data[0].every(
                item => {
                    let formattedItem = typeof item == 'string' ? item.trim() : item

                    return ['Nazwa klienta', 'Ulica', 'Kod pocztowy', 'Miasto', 'Kraj'].includes(formattedItem)
                }
            )) {
                return (this.isValidFileTrigger = false)
            }

            return (this.isValidFileTrigger = true)
        },
        onLoaded() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$emit('on-loaded', {data: this.xlsData, fileName: this.currentFile.name,
                payload:{contactPerson: this.shippingLabelAddress.contactPerson, phoneNumber: this.shippingLabelAddress.phoneNumber}})

            this.onClose()
        },
        onClose() {
            this.$emit('on-close')

            setTimeout(() => {
                this.shippingLabelAddress.contactPerson = null
                this.shippingLabelAddress.phoneNumber = null
                this.xlsData = null
                this.currentFile = null
                this.$v.$reset()
            }, 500)
        },
    }
}
</script>